import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import EditableText from "./EditableText";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 px-6 sm:px-10 bg-[#F4ECFF]">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <EditableText k="faq.eyebrow" fallback="Questions, answered" className="eyebrow" data-testid="faq-eyebrow" />
          <h2 className="editorial-display mt-5 text-4xl sm:text-5xl lg:text-6xl text-[#0B0A4A]" data-testid="faq-heading">
            <EditableText k="faq.heading" fallback="Everything you'd want to ask." />
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E0D0F5] last:border-b-0" data-testid={`faq-item-${i}`}>
              <AccordionTrigger
                className="text-left font-serif text-xl sm:text-2xl text-[#0B0A4A] hover:text-[#3E1A7A] hover:no-underline py-6"
                data-testid={`faq-trigger-${i}`}
              >
                <EditableText k={`faq.${i}.q`} fallback={item.q} />
              </AccordionTrigger>
              <AccordionContent className="text-base sm:text-lg text-[#0B0A4A]/75 font-sans leading-relaxed pb-6" data-testid={`faq-content-${i}`}>
                <EditableText k={`faq.${i}.a`} fallback={item.a} multiline />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
